import {NgModule} from  "@angular/core"
import {SortByAmount, SortByBankNamePipe, SortByBankNameWithdrawPipe} from "./pip";


@NgModule({
  declarations:[
    SortByBankNamePipe,
    SortByBankNameWithdrawPipe,
    SortByAmount
  ],
  imports:[

  ],
  exports:[
    SortByBankNamePipe,
    SortByBankNameWithdrawPipe,
    SortByAmount
  ]
})
export  class  CommonsPipsModule {}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/_services/pip.module.ts